import React from "react";
import {
  Box,
  Typography,
  Card,
  Stack,
  Button,
  Container,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import claimsucess from "../../assets/claimsucess.png";
import DaalchiniLogo from "../../assets/DaalchiniLogo.png";
import ArrowLeftCircleIcon from "../../assets/arrow-left-circle.png"; 
/***********************************
 Wrapper
************************************/
import {IMAGE_BASE_URL} from '../../config.js'
const Wrapper = ({ children }) => (
  <Box
    sx={{
      minHeight: "100vh",

      // ✅ gradient only desktop
      background: {
        xs: "#f3f4f6",
        sm: "linear-gradient(135deg,#eef2ff,#f8fafc)",
      },

      display: "flex",
      justifyContent: "center",

      // 🔥 critical for centering
      alignItems: { xs: "stretch", sm: "center" },

      p: { xs: 0, sm: 3 },
    }}
  >
    <Container maxWidth="sm" disableGutters>
      <Box
        sx={{
          bgcolor: "white",

          // ✅ mobile full height
          minHeight: { xs: "100vh", sm: "auto" },

          // ✅ desktop card
          maxHeight: { sm: "90vh" },
          overflowY: "auto",

          borderRadius: { xs: 0, sm: 4 },

          p: 3,

          // ✅ no shadow mobile
          boxShadow: {
            xs: "none",
            sm: "0 25px 70px rgba(0,0,0,0.12)",
          },
        }}
      >
        {children}
      </Box>
    </Container>
  </Box>
);

/***********************************
 Header
************************************/

const Header = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
      mb: 4,
    }}
  >
<img src={ArrowLeftCircleIcon} style={{ width: "24px", position: "absolute", left: 0, cursor: "pointer" }} />

    <img src={DaalchiniLogo} style={{ width: "120px" }} />
  </Box>
);

/***********************************
 Claim Card
************************************/

const ClaimCard = ({data,ClaimdigitalOrder}) => (
  <Card
    sx={{
      mt: 4,
      borderRadius: 3,
      p: 2,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",

      // no shadow mobile
      boxShadow: { xs: "none", sm: "0 6px 18px rgba(0,0,0,0.08)" },

      border: { xs: "1px solid #e5e7eb", sm: "none" },
    }}
  >
    <Stack direction="row" spacing={2} alignItems="center">
      {/* Logo */}
      <Box
        sx={{
          width: 48,
          height: 48,
          borderRadius: 2,
          overflow: "hidden",
          bgcolor: "#f3f4f6",
          flexShrink: 0,
        }}
      >
        <img
          src={`${IMAGE_BASE_URL}/${data.imageUrl}`}
          alt={data.itemName}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />
      </Box>

      <Box>
        <Typography fontWeight={700} style={{fontSize:"16px"}}>
         {data.itemName}
        </Typography>

        <Typography variant="body2" color="text.secondary" style={{fontSize:"12px"}}>
         {data.itemDescription}
        </Typography>
      </Box>
    </Stack>

    <Button
     onClick={(e)=>{ClaimdigitalOrder(data.lineItemId)}}
      variant="contained"
      sx={{
        bgcolor: "#12b981",
        borderRadius: 2,
        textTransform: "none",
        fontWeight: 700,
        
        px: 3,

        "&:hover": {
          bgcolor: "#0ea371",
        },
      }}
    >
      Claim
    </Button>
  </Card>
);

/***********************************
 Main Screen
************************************/

export default function Cliam({digitalorderData,ClaimdigitalOrder}) {
  return (
    <Wrapper>
      <Header />

      {/* Success Icon Section */}
      <Stack alignItems="center" spacing={2}>
        <img src={claimsucess} style={{ width: "120px" }} />

        <Typography fontWeight={800} fontSize={22}>
          You Are All Set To Claim
        </Typography>

        <Typography color="text.secondary">
          Order ID: A123D0076541237F
        </Typography>

        <Stack direction="row" spacing={1} alignItems="center">
          <AccessTimeIcon sx={{ color: "#f97316", fontSize: 18 }} />
          <Typography>Expires in 24hr</Typography>
        </Stack>
      </Stack>

{digitalorderData?.map((item, index) => (
  <ClaimCard 
    key={item.id || index}
    data={item}
    ClaimdigitalOrder={ClaimdigitalOrder}
  />
))}
    </Wrapper>
  );
}
